import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { skipToken } from '@reduxjs/toolkit/query'

import { selfHarmTasksStates } from '../../../common/constants/appConstants'
import { getAuthConfig, getAuthUserId } from '../../../data/auth/authSelectors'
import { useIsEngageDAProvider } from '../../../hooks/useIsEngageDAProvider'
import {
  useGetProviderSelfHarmTasksQuery,
  useGetProviderTriageRiskTasksQuery,
} from '../../../providers/dashboard/data/providerTasksApi'

export const useClientRiskFlags = (): Set<string> => {
  const userId = useSelector(getAuthUserId)
  const isDAEngage = useIsEngageDAProvider()
  const hideRiskAlerts = useSelector(getAuthConfig)?.hideRiskAlerts
  const queryArgs = hideRiskAlerts ? skipToken : { providerId: userId }
  const { data: selfHarmTasks } = useGetProviderSelfHarmTasksQuery(queryArgs)
  const { data: triageRiskTasks } = useGetProviderTriageRiskTasksQuery(isDAEngage ? queryArgs : skipToken)

  return useMemo(() => {
    const clientIds = new Set<string>()
    if (hideRiskAlerts) return clientIds

    const allTasks = [...(selfHarmTasks ?? []), ...(triageRiskTasks ?? [])]
    allTasks.forEach((task) => {
      const patientId = task.arguments?.patient_id
      if (patientId && task.status !== selfHarmTasksStates.INACTIVE) {
        clientIds.add(patientId)
      }
    })
    return clientIds
  }, [hideRiskAlerts, selfHarmTasks, triageRiskTasks])
}
